<template>
    <div class="register" v-if="userStatus === 'registered' || userStatus === 'registered_and_waiting'">
        <div class="register-wrapper">
            <simple-svg :filepath="'/storage/img/icon/icon-confirm.svg'" />

            <div class="register-wrapper--content">
                <h3>{{ 'w.event-registered.title'|t }}</h3>
                <p>{{ 'w.event-registered.text'|t }}</p>
                <router-link to="/dashboard" class="btn-link btn-link--small">{{ 'w.event-registered.cta'|t }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            status: null,
            userStatus: null
        }
    },
    mounted() {
        this.status = this.event.status;
        this.userStatus = this.event.userStatus;
    }
}
</script>
